(function($, Cobalt, undefined) {
    Cobalt.Constants = {
        StaticURL: null,
        initialize: function(data) {
            $.each(data, function(key, val) {
                Cobalt.Constants[key] = val;
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Constants.js